import React, {Component} from 'react'
import Punch from './Punch'
import punchData from './punchData'
import './Punch.css'

class PunchContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      punches: punchData
    }
  }

  handlePunch(name) {
    const punch = this.state.punches.find(p => p.name === name)
    if (punch.track.loaded) punch.track.start()
    setTimeout(() => {
      if (punch.track.state === 'started') {
        punch.track.stop()
      }
    }, 2000)
  }

  render() {
    const punchesTop = []
    const punchesBottom = []
    this.state.punches.forEach(punch => {
      if (punch.rowNum === 1) {
        punchesTop.push(<Punch 
          key={punch.id}
          id={punch.id}
          name={punch.name}
          icon={punch.icon}
          handlePunch={(name) => this.handlePunch(name)}
        />)
      } else if (punch.rowNum === 2) {
        punchesBottom.push(<Punch 
          key={punch.id}
          id={punch.id}
          name={punch.name}
          icon={punch.icon}
          handlePunch={(name) => this.handlePunch(name)}
        />)
      }
    })
    return (
      <div>
        <div className='subtitleBox'>
          <h3 className='subtitle punchTitle'>Punches</h3>
        </div>
        <div className='punchBox'>
          <div className='punchesTop'>
            {punchesTop}
          </div>
          <div className='punchesBottom'>
            {punchesBottom}
          </div>
        </div>
      </div>
    )
  }
}

export default PunchContainer


// WEBPACK FOOTER //
// ./src/Punch/PunchContainer.js